<script lang="ts">
	interface Props {
		height?: string // Default height
		width?: string // Default width
		class?: string
	}

	let { height = '48px', width = '48px', class: className = '' }: Props = $props()
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	fill="none"
	viewBox="0 0 48 48"
	{height}
	{width}
	class={className}
>
	<path
		d="M31.94 40L17.412 25.472C16.8627 24.9205 16.8627 24.0287 17.412 23.4772L31.94 8.9492"
		stroke="currentColor"
		stroke-width="4"
		stroke-linecap="round"
		stroke-linejoin="round"
	/>
</svg>
